/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateTemplate
 */
export interface UpdateTemplate {
  /**
   *
   */
  name: string;
}

/**
 * Check if a given object implements the UpdateTemplate interface.
 */
export function instanceOfUpdateTemplate(value: object): value is UpdateTemplate {
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function UpdateTemplateFromJSON(json: any): UpdateTemplate {
  return UpdateTemplateFromJSONTyped(json, false);
}

export function UpdateTemplateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateTemplate {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
  };
}

export function UpdateTemplateToJSON(json: any): UpdateTemplate {
  return UpdateTemplateToJSONTyped(json, false);
}

export function UpdateTemplateToJSONTyped(
  value?: UpdateTemplate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
  };
}
